import { SiteDirection } from '@wix/a11y-adapters';
import { domOrderRule, RuleId } from '@wix/a11y-rules';
import { convertScanStatusToUiStatus } from '../../../components/fixers/alt-image-fixer/utils';
import { SITE_LEVEL_PAGE_ID } from '../../../consts';
import { DOM_ORDER_FIX_OPTION } from './use-dom-order-rule';
const ruleChecker = domOrderRule.checker;
export const getUpdateDomOrderRuleStateOnApply = (siteCreationDate, newSiteLanguage, updateRuleStateAndVerifyIfNeeded, a11yWizardAdapter, experiments) => {
  return fixOption => {
    const isDomOrderAutoFix = fixOption.value === DOM_ORDER_FIX_OPTION.AUTO;
    const validSiteCreationDate = siteCreationDate ?? new Date('2020-01-01');
    const isSiteLanguageRTL = a11yWizardAdapter.getIsSiteLanguageRTL();
    const isSiteDirectionMatchingLanguageDirection = a11yWizardAdapter.getIsSiteDirectionMatchingLanguageDirection();
    const siteDomDirection = isSiteDirectionMatchingLanguageDirection ? isSiteLanguageRTL ? SiteDirection.RTL : SiteDirection.LTR : isSiteLanguageRTL ? SiteDirection.LTR : SiteDirection.RTL;
    const updatedRuleContext = {
      automaticDomOrderEnabled: isDomOrderAutoFix,
      isAutomaticallyCompleted: isDomOrderAutoFix,
      isManuallyCompleted: !isDomOrderAutoFix,
      siteCreationDate: validSiteCreationDate,
      siteLanguage: newSiteLanguage
    };
    const updatedStatus = convertScanStatusToUiStatus(ruleChecker({
      ...updatedRuleContext,
      siteDomDirection
    }, {
      isExperimentEnabled: spec => experiments.enabled(spec)
    }).status);
    updateRuleStateAndVerifyIfNeeded(SITE_LEVEL_PAGE_ID, RuleId.DOM_ORDER, {
      ...updatedRuleContext,
      status: updatedStatus
    });
  };
};
//# sourceMappingURL=get-update-dom-order-rule-state-on-apply.js.map